import React from "react";
import { motion } from "framer-motion";
import { Clock, LogOut, UserCheck, PawPrint, Cigarette, CreditCard, ShieldCheck } from "lucide-react";

const POLICIES = [
    { icon: Clock, title: "Check-in", desc: "4:00 PM – 11:30 PM, self check-in details shared before arrival." },
    { icon: LogOut, title: "Check-out", desc: "Before 10:00 AM so the home is flawless for the next guests." },
    { icon: UserCheck, title: "Minimum age 25", desc: "The booking guest must be 25 or older and present for the stay." },
    { icon: PawPrint, title: "No pets", desc: "To keep the villa allergy-friendly, pets are not permitted." },
    { icon: Cigarette, title: "No smoking", desc: "A fully smoke-free home, balcony included." },
    { icon: CreditCard, title: "Cashless payment", desc: "All payments are handled securely by card — no cash on arrival." },
];

export default function Policies() {
    return (
        <section id="policies" className="py-24 lg:py-32 bg-[#F3EDE2]" data-testid="policies-section">
            <div className="max-w-7xl mx-auto px-5 lg:px-8">
                <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }} className="max-w-2xl mb-12">
                    <p className="text-xs uppercase tracking-[0.3em] text-[#C49A45] font-semibold">Good to know</p>
                    <h2 className="font-serif-d font-light text-4xl sm:text-5xl lg:text-6xl text-[#0F2837] mt-4 leading-[1.05]">
                        Simple, honest <em className="text-[#2D6A76]">house rules.</em>
                    </h2>
                </motion.div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-testid="policies-grid">
                    {POLICIES.map(({ icon: Icon, title, desc }, i) => (
                        <motion.div key={title}
                            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-40px" }}
                            transition={{ duration: 0.6, delay: (i % 3) * 0.07 }}
                            className="rounded-3xl bg-white border border-[#E5DCCB] p-7"
                            data-testid={`policy-card-${i}`}>
                            <Icon size={20} className="text-[#C49A45]" />
                            <p className="mt-4 font-semibold text-[#0F2837]">{title}</p>
                            <p className="text-sm text-[#5C6A78] mt-2 leading-relaxed">{desc}</p>
                        </motion.div>
                    ))}
                </div>
                <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.2 }}
                    className="mt-8 flex items-start gap-3 rounded-3xl bg-[#0F2837] text-white p-7" data-testid="cancellation-note">
                    <ShieldCheck size={22} className="text-[#C49A45] shrink-0 mt-0.5" />
                    <p className="text-sm text-white/80 leading-relaxed">
                        <strong className="text-white">Cancellation terms</strong> depend on the rate selected at reservation time — some promotional rates are non-refundable. Final terms are always confirmed with you before any payment is taken.
                    </p>
                </motion.div>
            </div>
        </section>
    );
}
